export const CONFERENCE_INFO = {
    alwaysVisible: ['raised-hands-count', 'recording'],
    autoHide: [
        'highlight-moment',
        'subject',
        'conference-timer',
        'participants-count',
        'transcribing',
        'video-quality',
        'visitors-count',
        'insecure-room',
        'top-panel-toggle'
    ]
};
